import React from 'react'
import { Outlet } from 'react-router-dom'

import { Container } from '@mui/material'

const LegalLayout = () => (
  <Container maxWidth="md" sx={{ p: 4 }}>
    <Outlet />
  </Container>
)

export default LegalLayout
